import React from 'react';

const MetaTags = () => {
  return (
    <>
      {/* Basic Meta Tags */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content="Little Lemon - A family-owned Mediterranean restaurant serving authentic cuisine with a modern twist. Experience the flavors of the Mediterranean in every dish." />
      <meta name="keywords" content="Little Lemon, Mediterranean restaurant, family restaurant, Greek food, Turkish food, Italian food, restaurant booking, food delivery" />
      <meta name="author" content="Little Lemon Restaurant" />
      
      {/* Open Graph Protocol Tags */}
      <meta property="og:title" content="Little Lemon - Mediterranean Restaurant" />
      <meta property="og:description" content="Experience authentic Mediterranean cuisine at Little Lemon. Family-owned restaurant serving fresh, delicious dishes with a modern twist." />
      <meta property="og:type" content="restaurant" />
      <meta property="og:url" content="https://littlelemon.com" />
      <meta property="og:image" content="https://littlelemon.com/restaurant-banner.jpg" />
      <meta property="og:site_name" content="Little Lemon Restaurant" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Little Lemon - Mediterranean Restaurant" />
      <meta name="twitter:description" content="Experience authentic Mediterranean cuisine at Little Lemon. Family-owned restaurant serving fresh, delicious dishes with a modern twist." />
      <meta name="twitter:image" content="https://littlelemon.com/restaurant-banner.jpg" />
      
      {/* Additional Meta Tags */}
      <meta name="theme-color" content="#F4CE14" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://littlelemon.com" />
    </>
  );
};

export default MetaTags;